module.exports = __webpack_public_path__ + "static/kskimg2-321dd5b328304d0e0144957fb27bdbc2.gif";